import React, { Component } from 'react';
import TextInput from '../common/TextInput';
import { validationMessage, imageBasePath, appBasePath } from '../../constants/staticData';
import Button from '../common/Button';
import Gmaps from '../common/Gmaps';
import BusinessLandingHeader from '../BusinessLanding/BusinessLandingHeader.jsx';
import { FormGroup, FormControl } from 'react-bootstrap';

class ContactUs extends Component {
  constructor() {
    super();
    this.errors = {
      name: false,
      email: false,
      password: false,
      phone: false
      // 'terms': false
    };
  }
  render() {
    return (
      <div className="business-body">
        <BusinessLandingHeader router={this.props.router} metaTagKey={'contact-us'} />
        <div className="faq-banner">
          <div className="faq-img">
            <img src="images/contact.png" />
          </div>
          <div className="faq-desc">
            <h1> Contact Us </h1>
            <p> We'd love to hear from you. </p>
          </div>
        </div>
        <div className="contact-us">
          <div className="row">
            <div className="col-md-6 left">
              <span className="contact-title">Message Us</span>
              <div className="n-holder">
                <form>
                  <TextInput
                    type="text"
                    label="Name"
                    name="name"
                    showValidationError={this.errors['name']}
                    emptyError={validationMessage.name.emptyError}
                    validationError={validationMessage.name.validationError}
                  />
                  <TextInput
                    type="email"
                    label="Email"
                    name="email"
                    showValidationError={this.errors['email']}
                    emptyError={validationMessage.email.emptyError}
                    validationError={validationMessage.email.validationError}
                  />
                  <TextInput
                    type="phone"
                    label="Mobile Number"
                    name="phone"
                    showValidationError={this.errors['phone']}
                    emptyError={validationMessage.phone.emptyError}
                    validationError={validationMessage.phone.validationError}
                  />

                  <FormControl
                    className="textAlign message-textarea"
                    componentClass="textarea"
                    placeholder="Message"
                  />
                </form>
                <Button fontSize={16} label="MESSAGE" />
              </div>
            </div>
            <div className="col-md-6 right">
              <span className="contact-title">Reach out to Us</span>
              <div className="n-holder">
                <div className="n-sub-holder">
                  <span className="sub-title">CONTACT</span>
                  <span className="sub-content ph-no">+971 3265487921400</span>
                </div>
                <div className="n-sub-holder">
                  <span className="sub-title">LOCATION</span>
                  <span className="sub-content address">
                    880 Mill Creek Road, <br />Manahawkin, NJ 08050
                                    </span>
                </div>
                <div className="n-sub-holder">
                  <span className="sub-title">EMAIL</span>
                  <span className="sub-content email">customercar@carcility.com</span>
                </div>
                <div className="n-sub-holder map">
                  <Gmaps
                    setCenter={true}
                    center={{ lat: 0.23123123, lng: 0.343434232 }}
                    zoom={9}
                    containerElement={<div style={{ height: 240 + 'px', width: 'auto' }} />}
                    mapElement={<div style={{ height: 240 + 'px', width: 'auto' }} />}
                  />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContactUs;



// WEBPACK FOOTER //
// ./src/components/ContactUs/ContactUs.jsx